
import IFeature from "../IFeature.ts";
import GroundPlacementController from "./GroundPlacementController.ts";
import { GroundPlacementUI } from "./GroundPlacementUI.tsx";

class GroundPlacement implements IFeature {
  public ui = GroundPlacementUI;
  public controller = GroundPlacementController;
  public dependencies: IFeature[] = [];
}

export default GroundPlacement;